import { AxiosPromise } from 'axios';
import httpClient from 'api/httpClient';

export interface DeletePayPalMerchantAccountPayload {
  businessId: number;
  paypalMerchantAccountId: number;
}

/**
 * Soft-deletes the merchant account. CentsBE answers 409 while any store is still assigned to it.
 */
export const deletePayPalMerchantAccount = ({
  businessId,
  paypalMerchantAccountId,
}: DeletePayPalMerchantAccountPayload): AxiosPromise<{ success: boolean }> => {
  return httpClient({
    method: 'DELETE',
    url: `/super-admin/businesses/${businessId}/paypal-merchant-accounts/${paypalMerchantAccountId}`,
  });
};
